import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faFolderOpen,
  faListCheck,
  faClipboardCheck,
  faInbox,
  faUsers,
  faUserTie,
  faGear,
  faComments,
  faCalendarDays,
  faStar
} from '@fortawesome/free-solid-svg-icons';

const NavItem = ({ to, icon, children, onClick }) => (
  <NavLink to={to} onClick={onClick} className={({ isActive }) => `side-nav-item${isActive ? ' active' : ''}`}>
    <span className="side-nav-icon" aria-hidden="true">
      <FontAwesomeIcon icon={icon} />
    </span>
    <span className="side-nav-label">{children}</span>
  </NavLink>
);

const Sidebar = ({ user, onNavigate }) => {
  const role = user?.role || 'SALES';

  const groups = useMemo(() => {
    const core = [
      { to: '/dashboard', icon: faHome, label: 'Dashboard' },
      { to: '/projects', icon: faFolderOpen, label: 'Projects' }
    ];

    if (role !== 'CLIENT') {
      core.push({ to: '/tasks', icon: faListCheck, label: 'Tasks' });
    }

    const management = [];
    if (role !== 'CLIENT' && role !== 'DEVELOPER') {
      management.push({ to: '/approvals', icon: faClipboardCheck, label: 'Approvals' });
    }
    if (role === 'ADMIN' || role === 'BDM' || role === 'SALES') {
      management.push({ to: '/project-requests', icon: faInbox, label: 'Requests' });
    }

    const master = [];
    if (role === 'ADMIN') {
      master.push({ to: '/clients', icon: faUserTie, label: 'Clients' });
      master.push({ to: '/users', icon: faUsers, label: 'Users' });
    }
    if (role === 'BDM') {
      master.push({ to: '/clients', icon: faUserTie, label: 'Clients' });
      master.push({ to: '/users', icon: faUsers, label: 'Users' });
    }

    const other = [
      { to: '/client-issues', icon: faComments, label: 'Client Issues' },
      { to: '/feedback', icon: faStar, label: 'Feedback' },
      { to: '/calendar', icon: faCalendarDays, label: 'Calendar' }
    ];

    if (role === 'ADMIN') {
      other.push({ to: '/settings', icon: faGear, label: 'Settings' });
    }

    return [
      { title: 'Core', items: core },
      ...(management.length ? [{ title: 'Management', items: management }] : []),
      ...(master.length ? [{ title: 'Master', items: master }] : []),
      { title: 'Other', items: other }
    ];
  }, [role]);

  return (
    <aside className="app-sidebar" aria-label="Primary navigation">
      <div className="app-sidebar-inner">
        {groups.map((g) => (
          <div key={g.title} className="sidebar-group">
            <div className="sidebar-group-title">{g.title}</div>
            {g.items.map((it) => (
              <NavItem key={it.to} to={it.to} icon={it.icon} onClick={onNavigate}>
                {it.label}
              </NavItem>
            ))}
          </div>
        ))}
      </div>
    </aside>
  );
};

export default Sidebar;
